import React, {Component} from "react";
import MenuHeader from "./components/MenuHeader";
import UserMenu from "./Menus/UserMenu";
import MainMenu from "./Menus/MainMenu";
import SessionsMenu from "./Menus/SessionsMenu";

export default class SidebarMainMenu extends Component {
  render() {
    const {currentUser, onClose, match} = this.props;
    return (
      <React.Fragment>
        {this.renderSessions()}
        <MenuHeader className="mainMenuHeader">Main Menu</MenuHeader>
        <MainMenu match={match} currentUser={currentUser} onClose={onClose} />
        <MenuHeader>User Menu</MenuHeader>
        <UserMenu url={match.url} currentUser={currentUser} />
      </React.Fragment>
    );
  }

  renderSessions() {
    const {sessions, currentAccount, match} = this.props;
    if (sessions.length > 1) {
      return (
        <React.Fragment>
          <MenuHeader>Switch Accounts</MenuHeader>
          <SessionsMenu account={currentAccount} sessions={sessions} match={match} />
        </React.Fragment>
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Sidebar/SidebarMainMenu.jsx